var map = {
	"./i-advantages-desktop-03.svg": "8b31",
	"./i-dash-circle.svg": "16c1",
	"./i-features-01.svg": "0d85",
	"./i-features-02.svg": "f935",
	"./i-features-03.svg": "2eeb",
	"./i-features-04.svg": "b4e2",
	"./i-features-05.svg": "bfd9",
	"./i-features-scheme.svg": "d72b",
	"./i-file.svg": "e941",
	"./i-logo.svg": "7586",
	"./i-play.svg": "6ade",
	"./i-submit.svg": "4457",
	"./i-tick.svg": "81c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "530d";